import { composeIO } from 'react-compose-io'
import { itemStatusIO } from './ItemStatus.IO'
import { ItemStatusView } from './ItemStatus.View'

export const ItemStatus = composeIO(ItemStatusView, itemStatusIO)
